<template>
  <div>
    <My-new-nav ref="header"></My-new-nav>
    <div class="detail">
      <div class="title-bar" @click="$router.go(-1)">
        <img class="arrow" src="../../../assets/image/Mobile/back.png" alt="" />
        <span class="back">返回</span>
      </div>
      <div class="title">{{ news.title }}</div>
      <div class="time">{{ news.createTime }}</div>
      <img :src="news.imgUrl" alt="">
      <div class="content" v-html="news.content"></div>
    </div>
  </div>
</template>

<script>
import { selectNewsById } from "../../../../common/api";
import {
  hiddenLoading,
  showLoading,
  showToast,
} from "../../../../common/toast";

export default {
  name: "",
  data() {
    return {
      news: {},
    };
  },
  activated() {
    showLoading();
    const id = this.$route.params.id;
    selectNewsById({ id })
      .then((res) => {
        hiddenLoading();
        if (res.responseCode === 0) {
          this.news = res.responseBody;
        } else {
          showToast(res.responseMsg);
        }
      })
      .catch((e) => {
        console.log(e);
        showToast(e);
      })
  },
};
</script>

<style scoped lang="scss">
.detail {
  margin: 0 32px;
  min-height: 800px;
  img{
    width: 100%;
  }
}

.title-bar {
  margin-top: 110px;
  position: relative;

  .arrow {
    width: 46px;
    height: 46px;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translate(0, -50%);
  }

  .back {
    font-size: 42px;
    color: #999999;
    height: 120px;
    line-height: 120px;
    margin-left: 60px;
  }
}

.title {
  font-size: 54px;
  color: #333333;
  font-weight: 500;
  line-height: 90px;
}

.time {
  font-size: 42px;
  line-height: 75px;
  color: #999999;
  margin-top: 24px;
  margin-bottom: 24px;
}

.img {
  width: 100%;
  max-height: 1000px;
}

.content {
  margin-top: 24px;
  margin-bottom: 80px;

  ::v-deep img {
    width: 100%;
  }
  ::v-deep h4,
  ::v-deep p {
    color: #333333;
    line-height: 90px;
    font-size: 54px;
    font-weight: 400;

    strong {
      font-weight: normal;
      color: #333333 !important;
    }

    span {
      color: #333333 !important;
    }
  }
  ::v-deep .ql-align-center,
  ::v-deep h1,
  ::v-deep h6 {
    color: #333333;
    line-height: 90px;
    font-size: 44px;
    font-weight: 400;
    strong {
      font-weight: normal;
    }
  }
}
</style>
